import { useState } from 'react'
import type { QuestionProps } from '../eform.types'

export default function RadioOptions({ question, value, onChange, error }: QuestionProps) {
  const strValue = Array.isArray(value) ? value[0] ?? '' : value
  const [otherText, setOtherText] = useState('')

  function handleOptionSelect(optionId: string) {
    onChange(optionId)
  }

  function handleOtherChange(text: string) {
    setOtherText(text)
    onChange('other:' + text)
  }

  const isOtherSelected = strValue.startsWith('other:')
  const radioName = `radio_${question.orderId}`

  return (
    <div className="space-y-1">
      {question.options.map((opt) => {
        const optVal = String(opt.id)
        const isSelected = strValue === optVal
        return (
          <label
            key={opt.id}
            className={`flex items-center gap-2.5 rounded-md border px-3 py-2 cursor-pointer transition-all ${
              isSelected
                ? 'border-primary bg-primary/5 ring-1 ring-primary'
                : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50'
            }`}
          >
            <input
              type="radio"
              name={radioName}
              value={optVal}
              checked={isSelected}
              onChange={() => handleOptionSelect(optVal)}
              className="sr-only"
            />
            <div
              className={`h-4 w-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${
                isSelected ? 'border-primary' : 'border-slate-300'
              }`}
            >
              {isSelected && <div className="h-2 w-2 rounded-full bg-primary" />}
            </div>
            <span className="text-xs text-slate-700">{opt.text}</span>
          </label>
        )
      })}
      {question.addOther && (
        <label
          className={`flex items-center gap-2.5 rounded-md border px-3 py-2 cursor-pointer transition-all ${
            isOtherSelected
              ? 'border-primary bg-primary/5 ring-1 ring-primary'
              : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50'
          }`}
        >
          <input
            type="radio"
            name={radioName}
            value="__other__"
            checked={isOtherSelected}
            onChange={() => handleOtherChange(otherText)}
            className="sr-only"
          />
          <div
            className={`h-4 w-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${
              isOtherSelected ? 'border-primary' : 'border-slate-300'
            }`}
          >
            {isOtherSelected && <div className="h-2 w-2 rounded-full bg-primary" />}
          </div>
          <div className="flex-1">
            <span className="text-xs text-slate-700">Other</span>
            {isOtherSelected && (
              <input
                type="text"
                value={otherText}
                onChange={(e) => handleOtherChange(e.target.value)}
                placeholder="Please specify"
                className="mt-1.5 w-full rounded-md border border-slate-200 px-3 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                autoFocus
              />
            )}
          </div>
        </label>
      )}
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  )
}
